import { render, staticRenderFns } from "./ReviewDependents.vue?vue&type=template&id=7d42c097&"
import script from "./ReviewDependents.vue?vue&type=script&lang=js&"
export * from "./ReviewDependents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports